export const ABLE_PLAN = 'loseWeight';
